// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"38b964ca","239":"80777251","732":"e66cbee8","777":"03666515","977":"3ef73940"}[chunkId] + ".chunk.js";
};